export default "__VITE_ASSET__cbdf383c__"